import { AccountData } from "../generated";

export class News {
    version: Version;
    title: string;
    description: string;
    images: { url: string, imageDescription?: string }[]
}
export class Version {
    static parsingRegex: RegExp = /^(\d+\.)?(\d+\.)?(\*|\d+)$/;
    major: number;
    minor: number;
    build: number;

    constructor(version: string) {
        if (Version.parsingRegex.test(version)) {
            const result = Version.parsingRegex.exec(version);
            this.major = parseInt(result?.[1]?.replace(".", "") ?? "0");
            this.minor = parseInt(result?.[2]?.replace(".", "") ?? "0");
            this.build = parseInt(result?.[3]?.replace(".", "") ?? "0");
        }
        else {
            this.major = 0;
            this.minor = 0;
            this.build = 0;
        }
    }

    getValue() {
        return (this.major * 1000000) + (this.minor * 1000) + (this.build)
    }

    toString() {
        return `${this.major}.${this.minor}.${this.build}`;
    }
}

class __NewsRepository {
    get(version: string | undefined) {
        if (!version) return [];
        const lastVersion = new Version(version);
        return this._data.filter(x => x.version.getValue() > lastVersion.getValue())
    }
    getAll() {
        return this._data;
    }

    getForUser(user: AccountData | null) {
        return user == null || user.lastAccess == null ? [] : user.lastNewsVersion ? this.get(user.lastNewsVersion) : this.getAll();
    }

    private _data: News[] = [
        {
            version: new Version("2.5.37"),
            title: "Export Catasto SIERT",
            description: `È ora possibile esportare i rapporti di controllo nel formato richiesto dal catasto regionale SIERT direttamente da Caldaie Manager.
Seleziona il periodo di riferimento, scegli gli interventi da includere e avvia l'export: il sistema verifica automaticamente la correttezza di tutti i campi obbligatori prima di generare il file, mostrando eventuali errori campo per campo con indicazione precisa del valore mancante o non valido.
Il file esportato è nel formato TXT tabulato richiesto dal portale SIERT, pronto per l'importazione senza ulteriori modifiche.`,
            images: [{ url: require("../assets/images/news/integrazione-siert.png") }, { url: require("../assets/images/news/integrazione-siert2.png") }],

        },
        {
            version: new Version("2.0.1"),
            title: "Gestione impianti Frigo",
            description: `E' ora possibile gestire gli impianti frigo come condizionatori, pompe di calore e tanto altro!`,
            images: [
                { url: require("../assets/images/news/impianti-clima.png"), imageDescription: "Seleziona la tipologia di impianto da caricare" },
                { url: require("../assets/images/news/rapportocontrollo-frigo.png"), imageDescription: "Genera il rapporto di controllo gruppi frigo" },
            ]
        },
        {
            version: new Version("1.0.11"),
            title: "Localizza precisamente i tuoi clienti",
            description: `Localizza con precisione la posizione dell'abitazione del cliente evitanto di perdere tempo a cercare l'esatta posizione.`,
            images: [
                { url: require("../assets/images/news/customer-geocoding.gif") }
            ]
        },
        {
            version: new Version("1.0.11"),
            title: "Ottimizza gli appuntamenti dei tecnici",
            description: `Tramite la visualizzazione scadenze su mappa puoi visualizzare l'esatta posizione geografica dei tuoi 
            impianti in scadenza in modo da poter ottimizzare l'uscita del tecnico evitandogli di perdere tempo negli spostamenti.`,
            images: [
                { url: require("../assets/images/news/scadenze-map.gif") }
            ]
        },
        {
            version: new Version("1.0.19"),
            title: "Gestisci i tuoi tecnici",
            description: `Tramite la nuova funzionalità tecnici presente all'interno del menù azienda puoi ora inserire tutti i tuoi tecnici
            che potranno essere utilizzati negli appuntamenti e interventi.`,
            images: [
                { url: require("../assets/images/news/tecnici.gif") }
            ]
        },
        {
            version: new Version("1.0.19"),
            title: "Pianifica i tuoi interventi",
            description: `Gestisci e crea comodamente gli interventi presso i tuoi clienti abbianando uno dei tuoi tecnici.`,
            images: [
                { url: require("../assets/images/news/interventi.gif"), imageDescription: "Tramite il calendario interventi:" },
                { url: require("../assets/images/news/scadenze-intervento.gif"), imageDescription: "Oppure direttamente dalla schermata scadenze:" }
            ]
        },
        {
            version: new Version("1.0.29"),
            title: "Timbro e firma aziendale",
            description: `Precompila il rapporto di controllo con il tuo timbro e firma. Per attivarlo invia una scansione (alla massima risoluzione possibile) della tua firma o timbro all'indirizzo email info@caldaiemanager.it`,
            images: [
                { url: require("../assets/images/news/firma-allegato.jpg") },
            ]
        },
        {
            version: new Version("1.0.54"),
            title: "Salvataggio rapporti di controllo",
            description: `Ora è possibile salvare i rapporti di controllo generati per ogni impianto in modo da poter consultare in qualsiasi momento tutti i valori inseriti dal tecnico al momento del controllo`,
            images: [
                { url: require("../assets/images/news/generarapporto.png"), imageDescription: `Per generare un rapporto di controllo è necessario inserire il numero (che viene calcolato automaticamente) e l'intervento di riferimento.` },
                { url: require("../assets/images/news/salvarapporto.png"), imageDescription: "Una volta generato l'allegato e compilato i valori è possibile salvare i dati attraverso l'apposito tasto salva." }
            ]
        },
        {
            version: new Version("1.0.60"),
            title: "Firma cliente digitalizzata su rapporti di controllo",
            description: `Utilizza uno schermo touch per firmare il rapporto di controllo. Permetti al tuo tecnico di far firmare il documento direttamente nella sede del cliente.`,
            images: [
                { url: require("../assets/images/news/firma-rcee.gif"), imageDescription: `La firma digitalizzata (non è una firma digitale con valore notarile) ma è come quella fatta dai corrieri quando consegnano la merce presso il cliente. L'allegato firmato sarà consultabile in qualsiasi momento online anche a distanza di anni.` },
            ]
        },
        {
            version: new Version("1.0.67"),
            title: "Data primo avvio impianto",
            description: `Su ogni impianto ora puoi inserire anche la data di primo avvio oltre alla già presente data di installazione`,
            images: [
                { url: require("../assets/images/news/dataprimoavvio.png") },
            ]
        },
        {
            version: new Version("1.0.69"),
            title: "Pianificazione interventi",
            description: `Pianifica rapidamente i tuoi interventi direttamente dall'elenco scadenze.`,
            images: [
                { url: require("../assets/images/news/pianificazione-interventi.png"), imageDescription: "In questo modo puoi capire quali appuntamenti hai già preso e quelli che ti rimangono da prendere senza dover esporare o stampare l'elenco delle scadenze." },
            ]
        },
        {
            version: new Version("1.0.70"),
            title: "Archiviazione documentale",
            description: `Archivia e allega i documenti,foto,file relativi ai tuoi clienti comodamente dalla scheda cliente.`,
            images: [
                { url: require("../assets/images/news/archivazione-documentale1.png"), imageDescription: "Allegali direttamente dalla scheda del cliente" },
                { url: require("../assets/images/news/archivazione-documentale2.png"), imageDescription: "Una volta allegati puoi consultarli e scaricarli in qualsiasi momento e da qualiasi dispositivo" },
            ]
        },
        {
            version: new Version("1.0.76"),
            title: "Salvataggio dati catastali",
            description: `Aggiungi i dati catastali del cliente per ritrovarli già compilati nel rapporto di controllo.`,
            images: [
                { url: require("../assets/images/news/dati-catastali.png") },
            ]
        },
        {
            version: new Version("1.0.84"),
            title: "Bollino termico più preciso",
            description: `Ora è possibile inserire la reale e completa validità del bollino termico applicato al tuo impianto. In questo modo puoi tenere meglio traccia delle scadenze.`,
            images: [
                { url: require("../assets/images/news/bollino-periodo.gif") },
            ]
        },
        {
            version: new Version("1.0.84"),
            title: "Rapporto controllo biomasse",
            description: `Genera, salva e fai firmare il rapporto controllo per tutti gli impianti a biomasse.`,
            images: [
                { url: require("../assets/images/news/creazione-rapporto-biomasse.gif") },
                { url: require("../assets/images/news/rapporto-controllo-biomasse.png") },
            ]
        },
        {
            version: new Version("1.0.86"),
            title: "Calendario migliorato",
            description: `Seleziona più rapidamente l'anno e il mese con i nuovi selettori rapidi`,
            images: [
                { url: require("../assets/images/news/datepicker-newselector.png") },
            ]
        },
        {
            version: new Version("1.0.86"),
            title: "Aggiorna scadenze: Crea anche il bollino termico",
            description: `Nell'evasione rapida scadenze, nel caso venga fatto un controllo combustione, ora è possible creare direttamente anche il bollino termico e impostare la sua relativa validità`,
            images: [
                { url: require("../assets/images/news/evadiscadenza-bollino.png") },
            ]
        },
        {
            version: new Version("1.0.88"),
            title: "Contatta più rapidamente i clienti via WhatsApp",
            description: `Sui numeri di cellulare è ora possibile avviare rapidamente una chat whatsapp direttamente cliccando l'apposita icona.`,
            images: [
                { url: require("../assets/images/news/whatsapp-link.png") },
                { url: require("../assets/images/news/whatsapp-link.gif") },
            ]
        },
        {
            version: new Version("1.1.4"),
            title: "Invia rapidamente SMS e Email ai tuoi clienti.",
            description: `Ora puoi inviare sms e email direttamente da Caldaie Manager ai tuoi clienti. `,
            images: [
                { url: require("../assets/images/news/invia-notifiche-scadenze.gif"), imageDescription: "Dall'elenco scadenze seleziona i clienti che vuoi contattare e invia loro una comunicazione per prendere un appuntamento. Puoi salvare e memorizzare anche il tuo template sms e email predefinito." },
                { url: require("../assets/images/news/pacchetti-sms.png"), imageDescription: "Abbiamo regalato ai nostri clienti 10 sms gratuiti, puoi sempre acquistarne direttamente da Caldaie Manager selezionando uno dei nostri pacchetti." },
                { url: require("../assets/images/news/sms-residui.png"), imageDescription: "Puoi monitorare gli sms residui direttamente dalla tua dashboard" },
            ]
        },
        {
            version: new Version("1.1.9"),
            title: "Interventi dettagli migliorati",
            description: `Ora puoi inserire più dettagli all'interno dell'intervento, con quantità e importi.`,
            images: [
                { url: require("../assets/images/news/dettaglio-intervento.gif") },
            ]
        },
        {
            version: new Version("1.1.9"),
            title: "Rapportino intervento",
            description: `Ora puoi generare automaticamente il rapportino intervento direttamente dall'intervento`,
            images: [
                { url: require("../assets/images/news/rapportino-intervento.gif") },
            ]
        },
        {
            version: new Version("1.1.10"),
            title: "Interventi - inserimento rapido cliente",
            description: `Inserisci rapidamente una nuova anagrafica cliente per pianificare un intervento occasionale.`,
            images: [
                { url: require("../assets/images/news/interventi-cliente-inserimentorapido.png"), imageDescription: "Cliccando su nuovo" },
                { url: require("../assets/images/news/interventi-cliente-inserimentorapido2.png"), imageDescription: "Inserendo velocemente i suoi dati anagrafici" },
            ],
        },
        {
            version: new Version("1.1.10"),
            title: "Modifica cap indirizzo",
            description: `Ora puoi impostare un cap diverso da quello di default del comune.`,
            images: [
                { url: require("../assets/images/news/cap-cliente.png") },
            ],
        },
        {
            version: new Version("1.1.10"),
            title: "Scadenze - Visualizzazione contratti scaduti",
            description: `Dalla maschera delle scadenze ora vengono visualizzati anche i contratti di manutenzione in scadenza.`,
            images: [
                { url: require("../assets/images/news/scadenze-contratti.png") },
            ],
        },
        {
            version: new Version("1.1.11"),
            title: "Impianti - Campi non più obbligatori",
            description: `Matricola e Data Installazione non più obbligatori`,
            images: [
                { url: require("../assets/images/news/matricola-datainst-no.png"), imageDescription: "Ora puoi evitare di scrivere queste informazioni se non ne sei a conoscenza" },
            ],
        },
        {
            version: new Version("1.1.18"),
            title: "Agenda Tecnici - Sincronizzazione con Google, Ios, Outlook",
            description: `Sincronizza automaticamente gli appuntamenti e interventi dei tuoi tecnici inseriti su caldaie manager direttamente sul telefono del tecnico (Android, Ios, Outlook, ecc..)`,
            images: [
                { url: require("../assets/images/news/integrazione-calendari-esterni.jpg") },
                { url: require("../assets/images/news/sincronizza-agenda-button.png"), imageDescription: "Da agenda tecnici clicca sul tasto in alto a destra e segui le istruzioni." },
            ],
        },
        {
            version: new Version("1.1.19"),
            title: "Rapporto controllo Piemonte",
            description: `Aggiunto il nuovo modello di rapporto di controllo per la regione Piemonte`,
            images: [
                { url: require("../assets/images/news/rapporto-controllo-piemonte1.png") },
                { url: require("../assets/images/news/rapporto-controllo-piemonte2.png") },
            ],
        },
        {
            version: new Version("1.1.30"),
            title: "Ricerca avanzata per Pdr Pod Targa",
            description: `Ora è possibile ricercare i clienti per i codici impianto Pdr o Pod o Targa`,
            images: [
                { url: require("../assets/images/news/CodCatastoRicerca.png") },
            ],
        },
        {
            version: new Version("1.1.30"),
            title: "Installatore impianto",
            description: `Ora è possibile specificare il tecnico che ha effettuato l'installazione di un impianto`,
            images: [
                { url: require("../assets/images/news/InstallatoreImpianto.png") },
            ],
        },

    ]
}

export default new __NewsRepository();